import Editor from './base/editor';
export default Editor.extend({
  keysToTriggerClose: [9, 13, 27],
  classNames: ['is-light-theme', 'composer-block-html-editor'],
  actions: {
    edit() {
      this.set('isEditMode', true);
    }
  }
});